import React, { useState } from 'react';

function Navigacija({ aktivna, setAktivna, korisnik, onLogout, jeAdmin, jeGost, globalnaSezona, setGlobalnaSezona, sezone, brojaGresaka }) {
  const [meniOtvoren, setMeniOtvoren] = useState(false);

  const stavke = [
    { id: 'pocetna',    naziv: 'Početna',    ikona: '🏠' },
    { id: 'utakmice',  naziv: 'Utakmice',   ikona: '🎳' },
    { id: 'treninzi',  naziv: 'Treninzi',   ikona: '🏋️' },
    { id: 'igraci',    naziv: 'Igrači',     ikona: '👤' },
    { id: 'ranglista', naziv: 'Rang lista', ikona: '🏆' },
    { id: 'raspored',  naziv: 'Raspored',   ikona: '📅' },
    { id: 'turniri',   naziv: 'Turniri',    ikona: '🥇' },
    { id: 'izvjestaji',naziv: 'Izvještaji', ikona: '📊' },
  ];
  if (jeAdmin) stavke.push({ id: 'logi', naziv: 'Logi', ikona: '🪲', badge: brojaGresaka });

  const navigiraj = (strana) => {
    setAktivna({ strana });
    setMeniOtvoren(false);
  };

  return (
    <nav className="nav-wrapper">
      {/* ── Top bar (uvijek vidljiv) ── */}
      <div className="nav-topbar">
        <div className="nav-logo" onClick={() => navigiraj('pocetna')} style={{ cursor: 'pointer' }}>
          <span style={{ fontSize: '22px' }}>🎳</span>
          <span style={{ fontWeight: '700', color: '#fff', fontSize: '16px' }}>Arena Bakarni</span>
          {jeGost && <span className="badge badge-gold" style={{ fontSize: '10px' }}>Gost</span>}
        </div>

        {/* Desktop: sezona + korisnik + odjava */}
        <div className="nav-right-desktop">
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ fontSize: '11px', color: '#666688', textTransform: 'uppercase' }}>Sezona:</span>
            <select value={globalnaSezona} onChange={e => setGlobalnaSezona(e.target.value)} className="nav-sezona-select">
              {sezone.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '13px', fontWeight: '600', color: '#fff' }}>{korisnik?.ime}</div>
            <div style={{ fontSize: '11px', color: jeAdmin ? '#e94560' : jeGost ? '#ffc107' : '#2ed573' }}>
              {jeAdmin ? '🔐 Admin' : jeGost ? '👁️ Gost' : '👤 Igrač'}
            </div>
          </div>
          <button onClick={onLogout} className="btn-odjava">Odjava</button>
        </div>

        {/* Mobile: sezona select + hamburger */}
        <div className="nav-right-mobile">
          <select value={globalnaSezona} onChange={e => setGlobalnaSezona(e.target.value)} className="nav-sezona-select">
            {sezone.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <button className="hamburger" onClick={() => setMeniOtvoren(o => !o)}
            aria-label="Meni">
            {meniOtvoren ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* ── Desktop navigacijski linkovi ── */}
      <div className="nav-links-desktop">
        {stavke.map(s => (
          <button key={s.id} onClick={() => navigiraj(s.id)}
            className={'nav-link' + (aktivna.strana === s.id ? ' active' : '')}>
            {s.naziv}
            {s.badge > 0 && aktivna.strana !== s.id && (
              <span className="nav-badge">{s.badge}</span>
            )}
          </button>
        ))}
      </div>

      {/* ── Mobile overlay meni ── */}
      {meniOtvoren && (
        <div className="nav-mobile-meni">
          {/* Korisnik + odjava */}
          <div className="nav-mobile-user">
            <div>
              <div style={{ fontWeight: '700', color: '#fff' }}>{korisnik?.ime}</div>
              <div style={{ fontSize: '12px', color: jeAdmin ? '#e94560' : jeGost ? '#ffc107' : '#2ed573' }}>
                {jeAdmin ? '🔐 Admin' : jeGost ? '👁️ Gost' : '👤 Igrač'}
              </div>
            </div>
            <button onClick={() => { onLogout(); setMeniOtvoren(false); }} className="btn-odjava">Odjava</button>
          </div>
          {/* Nav stavke */}
          {stavke.map(s => (
            <button key={s.id} onClick={() => navigiraj(s.id)}
              className={'nav-mobile-link' + (aktivna.strana === s.id ? ' active' : '')}>
              <span style={{ fontSize: '18px', width: '28px' }}>{s.ikona}</span>
              {s.naziv}
              {s.badge > 0 && aktivna.strana !== s.id && (
                <span className="nav-badge" style={{ marginLeft: 'auto' }}>{s.badge}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}

export default Navigacija;
